import type React from 'react';
import { type KeyedExternalFile } from '.';
import ExternalFilesContext from '@/components/FileAttachments/ExternalFilesContext';
import { type DatabaseExternalFile } from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';

type NewLogEntryExternalFilesContextProviderProps = {
  externalFiles: KeyedExternalFile[];
  children: React.ReactNode;
};

const NewLogEntryExternalFilesContextProvider = ({
  externalFiles,
  children,
}: NewLogEntryExternalFilesContextProviderProps) => (
  <ExternalFilesContext.Provider
    value={{
      // Not the greatest construction, but we need this only for the OneDrive
      // file picker to know whether files are already attached.
      externalFiles: externalFiles as unknown as DatabaseExternalFile[],
      externalFilesExternalIds: externalFiles.map(
        externalFile => externalFile.externalFile.externalId,
      ),
      externalFilesEndpoint: '',
      addExternalFileToLocalState: dummyFunction,
      removeExternalFileFromLocalState: dummyFunction,
    }}
  >
    {children}
  </ExternalFilesContext.Provider>
);

export default NewLogEntryExternalFilesContextProvider;
